import { Box, Container, Link, Paper, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { Logo } from '@/shared/ui';

export const AuthFormLayout = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      py: 3,
    }}
  >
    <Container maxWidth="sm" sx={{ mb: 4 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Link href="https://torquetitan.ai" underline="none">
          <Logo />
        </Link>

        <Typography variant="h6">Start managing your shop today</Typography>
      </Box>
    </Container>

    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        px: { xs: 1, sm: 2 },
        pt: { xs: 1, sm: 2 },
        pb: { xs: 4, sm: 0 },
      }}
    >
      <Container maxWidth="sm" sx={{ width: '100%' }}>
        <Paper elevation={0} sx={{ p: 4, mx: 'auto', width: 'auto', minHeight: 'auto', mb: 4 }}>
          <Outlet />
        </Paper>
      </Container>
    </Box>
  </Box>
);
